import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['nav', 'trigger'];
  static classes = ['minimized'];

  connect() {
    if (this.hasTriggerTarget) {
      this.observer = new IntersectionObserver((entries) => {
        entries[0].intersectionRatio <= 0 ? this.minimise() : this.maximise();
      });

      this.observer.observe(this.triggerTarget);
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  minimise() {
    if (this.hasNavTarget) this.navTarget.classList.add(this.minimizedClass);
  }

  maximise() {
    if (this.hasNavTarget) this.navTarget.classList.remove(this.minimizedClass);
  }
}
